import ArtistCode from './ArtistCode';

export default ArtistCode;
